import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMGroupPermissionsApi = createApi({
  reducerPath: 'uMGroupPermissionsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  endpoints: (builder) => ({
    listGroupPermissions: builder.query({
      query: (params) => ({
        url: `users/auth-group-permissions/`,
        params,
      }),
    }),
    assignPermissionToGroup: builder.mutation({
      query: (data) => ({
        url: `users/auth-group-permissions/`,
        method: 'POST',
        body: data,
      }),
    }),
    deletePermissionFromGroup: builder.mutation({
      query: (id) => ({
        url: `users/auth-group-permissions/${id}/`,
        method: 'DELETE',
      }),
    }),
    bulkDeletePermissionFromGroup: builder.mutation({
      query: (data) => ({
        url: `users/auth-group-permissions/`,
        method: 'DELETE',
        body: data,
      }),
    }),
  }),
});

export const {
  useListGroupPermissionsQuery,
  useAssignPermissionToGroupMutation,
  useDeletePermissionFromGroupMutation,
  useBulkDeletePermissionFromGroupMutation,
} = uMGroupPermissionsApi;
